import styled from 'styled-components';

import {
  margin,
  MarginProps,
  padding,
  PaddingProps,
  rect,
  RectProps,
} from '../../../components/styles';
import { AppTheme } from '../../../styles/theme';

export const Img = styled.img<
  MarginProps &
    PaddingProps &
    RectProps & {
      radii?: keyof AppTheme['radii'];
      boxShadow?: keyof AppTheme['boxShadow'];
    }
>`
  border-radius: ${({ theme, radii }) => radii && theme.radii[radii]};
  box-shadow: ${({ theme, boxShadow }) =>
    boxShadow && theme.boxShadow[boxShadow]};
  ${margin};
  ${padding};
  ${rect};
`;
